import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcMuteIcon } from '@gem/icons';
import { Trans, useTranslation } from '@gem/modules/i18n';
import { IconView, popupItemStyles, Switch } from '@gem/ui-kit';

import { useProfileNotificationsPresenter } from './ProfileNotifications.presenter';
import styles from './ProfileNotifications.styles.m.css';

interface IProfileNotificationsProps {
  className?: string;
}

export const ProfileNotifications: FC<IProfileNotificationsProps> = observer(({ className }) => {
  const { t } = useTranslation();
  const { isEnabled, settingsLink, onClick } = useProfileNotificationsPresenter();

  return (
    <>
      <label
        className={classNames(
          styles.switchContainer,
          popupItemStyles.container,
          popupItemStyles.interactive
        )}
      >
        <IconView
          className={styles.icon}
          Icon={IcMuteIcon}
        />
        <span className={styles.title}>{t('notifications')}</span>

        <Switch
          className={styles.switch}
          isChecked={isEnabled}
          onChange={onClick}
        />
      </label>

      {settingsLink && (
        <>
          <div className={styles.deviceSystemActions}>
            <Trans
              translateKey="settins_system_push"
              keyParams={{
                0: (
                  <a
                    className={styles.deviceSystemLink}
                    href={settingsLink}
                  >
                    {t('settins_system_push_device')}
                  </a>
                ),
              }}
            />
          </div>
          <div className={styles.divider}></div>
        </>
      )}
    </>
  );
});
